import type { FaireProductEntity } from "../../entity_types/product";

export const p_2r4v4zemax: FaireProductEntity = {
  token: "p_2r4v4zemax",
  type: "product",
  name: "Fluorite Crystal Chips. 1lb.",
  brandToken: "b_8h5sk43qpz",
  brandName: "Down To Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/147dd11178a6a390d3b195ee2b2ec0d2e106972b2e7f2888054725bc263bf345.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b66e7e09e59bdf8198a3fcef53bab734f7b0d92af1a8aba3bdd9bc6c7d0475b.jpeg",
    "https://cdn.faire.com/fastly/cab54058b6f2e48c2673afd9e0ae6b401a8c2d80f7071e57748054505e136a2a.jpeg",
    "https://cdn.faire.com/fastly/c8ed1b2de3f0ecd0cba9bc39493f207a94398c981286b422da25475e9f2357bc.jpeg",
  ],
  priceDollars: 8.31,
  description:
    "6 to 9mm sized Fluorite Chips.\n\nAwaken the realms of higher consciousness and spiritual harmony with our ethereal Fluorite crystal chips. Sized between 6 to 9mm, each chip is a tiny powerhouse of balance and clarity, echoing the cosmic dance of the universe within its multicolored hues. Fluorite, renowned for its properties of spiritual enhancement and protection, serves as a bridge between the human mind and the vast cosmos, helping to align one's energies and intentions with the greater flow of existence. Whether integrated into jewelry, meditation practices, or energy grids, these chips are ideal for those who seek to amplify intuition, dispel negative energies, and embrace the profound wisdom of the universe. Invite the harmonizing energies of Fluorite into your sacred spaces and experience the transformative power of the cosmos within your grasp.\n",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:29.698Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
